import { gql } from 'graphql-request';

const updateCarMutation = gql`
  mutation ($carId: String!, $make: String!, $color: String!, $licenseNumber: String) {
    updateCar(carId: $carId, make: $make, color: $color, licenseNumber: $licenseNumber) {
      id
    }
  }
`;

export default updateCarMutation;
